import { render, staticRenderFns } from "./AlchemyResourceArc.vue?vue&type=template&id=4f8c365a&scoped=true"
import script from "./AlchemyResourceArc.vue?vue&type=script&lang=js"
export * from "./AlchemyResourceArc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c365a",
  null
  
)

export default component.exports